import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export function Parallax({ src, alt, className = "", amount = 12, sizes = "100vw", children }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${amount}%`, `${amount}%`]);
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        sizes={sizes}
        loading="lazy"
        decoding="async"
        style={reduced ? undefined : { y, scale: 1 + amount / 40 }}
        className="absolute inset-0 w-full h-full object-cover will-change-transform"
      />
      {children}
    </div>
  );
}
